export default __webpack_public_path__ + "static/media/element4.3be5b023.svg";